import '../scss/style.scss'

import ScrollSpy from "scrollspy";
import {DynamicResponsiveChecker, DynamicResponsiveGroup} from "responsive-checker";
import {smoothScrollTo} from "scrollspy/smooth-scrolling-poyfill.js";
import initSeparatorImages from "./separatorImages.ts";
import AnimationHandler from "./butterfly-animation";

function updateScrollspy(scrollspy) {
    if (document.body.classList.contains('responsive-1')) {
        document.querySelectorAll('.page').forEach(page => {
            page.style.minHeight = 'auto'
        })
    }

    scrollspy.config.pageSelector = document.body.classList.contains('responsive-1') ? null : '.page'
    scrollspy.topPosition = document.body.classList.contains('responsive-1') ? 'auto' : window.innerHeight - 200
}

window.addEventListener('load', () => {

    const linkGroups = [
        new DynamicResponsiveGroup(
            'menu.main-menu.desktop ul.main li:last-child',
            'menu.main-menu.desktop ul.submenu li:not(.social)',
            30,
            'menu.main-menu.desktop',
        )
    ];

    if (document.body.classList.contains('single')) {
        linkGroups.push(
            new DynamicResponsiveGroup(
                'menu.main-menu.desktop ul.main li:last-child',
                'menu.main-menu.desktop ul.submenu li.social',
                30,
                'menu.main-menu.desktop ul.submenu li.social',
            )
        )
    }

    linkGroups.push(
        new DynamicResponsiveGroup(
            'menu.main-menu.desktop .left',
            'menu.main-menu.desktop ul.main li',
            30,
            'menu.main-menu.desktop .left .text',
        )
    )

    const responsiveChecker = new DynamicResponsiveChecker(linkGroups)

    let scrollspy = null;

    if ( ! document.body.classList.contains('single')) {
        scrollspy = new ScrollSpy({
            duration: 600,
            top: 10
        });

        window.addEventListener('resize', () => {
            updateScrollspy(scrollspy)
        })

        updateScrollspy(scrollspy)

    } else {
        document.querySelector('#toplink').addEventListener('click', e => {
            e.preventDefault();
            smoothScrollTo(document.querySelector('#top'), 600);
        })
    }

    document.querySelectorAll('.menu-toggle').forEach(link => {
        link.addEventListener('click', () => sidebar.toggle());
    })

    document.querySelectorAll('#sidebar a').forEach(link => {
        if ( ! link.parentNode.classList.contains('has-sub')) {
            link.addEventListener('click', () => {
                sidebar.close();
            })
        }
    });

    document.querySelectorAll('.submenu').forEach(submenu => {
        const links = submenu.querySelectorAll('.link');

        if (links && 'undefined' !== typeof links[0]) {
            links[0].addEventListener('click', e => {
                e.preventDefault()
                smoothScrollTo(document.body.offsetHeight, 600)
            })
        }
    })
    // smoothScrollTo($('.imprint'))

    document.querySelectorAll('.main-menu.mobile a').forEach(link => {
        link.addEventListener('click', () => {
            link.parentNode.parentNode.parentNode.classList.remove('visible')
        })
    })

    initSeparatorImages(images => {
        if (scrollspy) {
            scrollspy.updatePageHeight();
            scrollspy.loadPagePositions();
        }
    })

    AnimationHandler.register(() => {
        scrollspy.loadPagePositions()
    });

    window.SF = {
        scrollspy,
        responsiveChecker
    }

    if ('undefined' !== typeof document.querySelector('#gallery')) {
        jQuery('#gallery a').fancybox();

        window.openGallery = () => {
            jQuery('#gallery a:first-child').trigger('click')
        }
    }

    let id = 1
    document.querySelectorAll('.wp-block-gallery').forEach(gallery => {
        const galleryId = 'gallery-' + id

        gallery.querySelectorAll('img').forEach(image => {
            const link = document.createElement('a')
            link.setAttribute('href', image.src)
            link.setAttribute('data-fancybox', galleryId)

            jQuery(image.parentNode).wrap(link)
        })

        id ++
    })

    document.querySelectorAll('.fader').forEach(fader => {
        const timeout = parseInt(fader.getAttribute('data-next'))
        const images = fader.querySelectorAll('li')

        let iterator = 0
        const next = () => {
            images.forEach(img => {
                img.classList.remove('next')
                img.classList.remove('active')
            })
            if (iterator + 1 === images.length) {
                images[iterator].classList.add('active')
                images[0].classList.add('next')
            } else {
                images[iterator].classList.add('active')
                images[iterator + 1].classList.add('next')
            }
            iterator ++
            if (iterator === images.length) {
                iterator = 0
            }
            setTimeout(() => {
                images.forEach(img => img.classList.remove('initial'))
                next()
            }, timeout)
        }

        next()
    })
});
